import React from "react";
import { Avatar } from "antd";
import { Tags } from "@worcket/common/components/listing";

import { getOptimizedImage } from "../../utils/images";

import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .row {
    display: flex;
    align-items: center;
  }

  .avatar {
    background-color: transparent;
    border-radius: 50%;
    margin-right: 16px;
    min-height: 96px;
    min-width: 96px;

    img {
      object-fit: contain;
    }
  }

  .information {
    display: flex;
    flex-direction: column;

    .title {
      font-size: 32px;
      color: ${({ theme }) => theme["@dark"]};
    }

    .subtitle {
      font-size: 16px;
    }
  }
`;

const Header = ({ children, image, title, subtitle, tags }) => {
  return (
    <Container data-test="header">
      <div className="left row">
        {image && (
          <Avatar
            src={getOptimizedImage(image)}
            className="avatar"
            size={128}
            icon="user"
          />
        )}
        <div className="information">
          {title && <b className="title">{title}</b>}
          {subtitle && <span className="subtitle">{subtitle}</span>}
          {tags && <Tags value={tags} />}
        </div>
      </div>
      {children}
    </Container>
  );
};

export default Header;
